<template>
  <div class="product-detail">
    <!-- 顶部标题区域 -->
    <section class="products-header">
      <div class="container">
        <h1 class="page-title">
          <span class="title-glow">产品详情</span>
        </h1>
        <p class="page-subtitle">深入了解我们的产品</p>
      </div>
    </section>

    <!-- 主内容区域 -->
    <section class="detail-main">
      <div class="container">
        <!-- 返回按钮 -->
        <div class="back-button">
          <button @click="goBack" class="btn-back">
            <span>←</span> 返回产品中心
          </button>
        </div>

        <!-- 加载状态 -->
        <div v-if="loading" class="detail-loading">
          <div class="loading-spinner"></div>
          <p>加载中...</p>
        </div>
        <!-- 错误提示 -->
        <div v-else-if="error" class="detail-error">
          <p>{{ error }}</p>
          <p class="error-hint">请确保 Node.js 服务器正在运行（端口 3000）</p>
        </div>
        <!-- 产品详情卡片 -->
        <div v-else-if="productDetail" class="detail-card">
          <!-- 产品标题 -->
          <div class="detail-header">
            <h2 class="detail-title">{{ productDetail.title }}</h2>
            <div class="detail-meta">
              <span class="detail-category">{{ productDetail.category }}</span>
              <span class="detail-date">更新日期: {{ productDetail.updatedAt }}</span>
            </div>
          </div>

          <!-- 产品图片 -->
          <div class="detail-image" v-if="productDetail.image">
            <img :src="resolveProductImage(productDetail.image)" :alt="productDetail.title" />
          </div>

          <!-- 产品简介 -->
          <div class="detail-intro" v-if="productDetail.intro">
            <h3 class="intro-title">产品简介</h3>
            <p class="intro-content">{{ productDetail.intro }}</p>
          </div>

          <!-- 产品优势 -->
          <div class="detail-advantages" v-if="productDetail.highlights && productDetail.highlights.length">
            <h3 class="advantages-title">产品优势</h3>
            <div class="advantages-content">
              <ul class="advantages-list">
                <li v-for="(highlight, index) in productDetail.highlights" :key="index">{{ highlight }}</li>
              </ul>
            </div>
          </div>

          <!-- 应用场景 -->
          <div class="detail-scenarios" v-if="productDetail.scenarios && productDetail.scenarios.length">
            <h3 class="scenarios-title">应用场景</h3>
            <div class="scenarios-content">
              <ul class="scenarios-list">
                <li v-for="(scenario, index) in productDetail.scenarios" :key="index">{{ scenario }}</li>
              </ul>
            </div>
          </div>

          <!-- 技术架构 -->
          <!-- <div class="detail-architecture" v-if="productDetail.techStack && productDetail.techStack.length">
            <h3 class="architecture-title">技术架构</h3>
            <div class="architecture-content">
              <p>平台采用业界领先的大数据技术栈，包括：</p>
              <div class="tech-stack">
                <span v-for="(tech, index) in productDetail.techStack" :key="index" class="tech-tag">{{ tech }}</span>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from 'axios'

// 使用 require.context 让 webpack 在打包时收集产品详情图片资源
// require.context 需要使用相对路径，不能使用别名
const productImageCtx = require.context('@/assets/products/img_detail', false, /\.png$/)

export default {
  name: 'ProductDetail',
  data() {
    return {
      productDetail: null,
      loading: false,
      error: null
    }
  },
  async mounted() {
    const productId = this.$route.query.id
    if (productId) {
      await this.fetchProductDetail(productId)
    } else {
      this.error = '缺少产品ID参数'
      this.loading = false
    }
  },
  methods: {
    async fetchProductDetail(productId) {
      try {
        this.loading = true
        this.error = null
        const response = await axios.get(`/api/products/detail/${productId}`)
        if (response.data.code === 200) {
          this.productDetail = response.data.data
        } else {
          this.error = response.data.message || '获取产品详情失败'
          this.productDetail = null
        }
      } catch (error) {
        console.error('获取产品详情失败:', error)
        if (error.response && error.response.status === 404) {
          this.error = '产品详情不存在'
        } else {
          this.error = '网络请求失败，请检查服务器是否运行'
        }
        this.productDetail = null
      } finally {
        this.loading = false
      }
    },
    goBack() {
      const section = this.$route.query.section || 'big-data-platform'
      this.$router.push({
        path: '/products',
        hash: section ? `#${section}` : '#big-data-platform'
      })
    },
    resolveProductImage(imagePath) {
      if (!imagePath) return ''
      // JSON 中配置的是 "@img_detail/filename.png"
      if (imagePath.startsWith('@img_detail/')) {
        const fileName = imagePath.replace('@img_detail/', '')
        try {
          return productImageCtx('./' + fileName)
        } catch (e) {
          console.warn('产品详情图片未找到:', fileName, e)
          return ''
        }
      }
      // 其他情况直接返回原路径（例如外部 URL）
      return imagePath
    }
  }
}
</script>

<style scoped>
.product-detail {
  min-height: 100vh;
  /* padding-top: 70px; */
  background: #f5f7fa;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 顶部标题区域 */
.products-header {
  position: relative;
  background-image: url('@/assets/background_header/产品中心详情页.png');
  background-size: cover;
  background-position: center;
  padding: 45px 0;
  overflow: hidden;
  min-height: 200px;
  display: flex;
  align-items: center;
}

.products-header .container {
  position: relative;
  z-index: 2;
  width: 100%;
  margin: 0;
  padding: 0 60px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
}

.page-title {
  position: relative;
  z-index: 2;
  margin: 0;
  text-align: left;
  padding: 0;
}

.page-subtitle {
  margin: 8px 0 0 0;
  text-align: left;
  font-size: 16px;
  color: rgba(255, 255, 255, 0.8);
  font-style: italic;
  line-height: 1.8;
  opacity: 1;
  max-width: 900px;
  margin-left: 2em;
  position: relative;
  z-index: 2;
  backdrop-filter: blur(5px);
}

.title-glow {
  display: inline-block;
  font-size: 46px;
  font-weight: 900;
  font-family: 'Arial Black', 'Microsoft YaHei', sans-serif;
  letter-spacing: 5px;
  color: #ffffff;
  filter: drop-shadow(0 0 10px rgba(96, 165, 250, 0.6));
  position: relative;
  backdrop-filter: blur(5px);
}

/* 主内容区域 */
.detail-main {
  background: #f5f7fa;
  padding: 40px 0 80px 0;
}

/* 返回按钮 */
.back-button {
  margin-bottom: 30px;
}

.btn-back {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  font-size: 14px;
  color: #4c95e3;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-back:hover {
  color: white;
  background: #4c95e3;
  border-color: #4c95e3;
}

.btn-back span {
  font-size: 18px;
}

/* 详情卡片 */
.detail-card {
  background: white;
  border-radius: 12px;
  padding: 40px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

/* 详情头部 */
.detail-header {
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 2px solid #f0f0f0;
}

.detail-title {
  font-size: 32px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 15px 0;
  line-height: 1.4;
}

.detail-meta {
  display: flex;
  align-items: center;
  gap: 20px;
  font-size: 14px;
  color: #666;
}

.detail-category {
  padding: 4px 12px;
  background: #f0f7ff;
  color: #4c95e3;
  border-radius: 4px;
  font-weight: 500;
}

.detail-date {
  color: #999;
}

/* 产品图片 */
.detail-image {
  width: 100%;
  margin-bottom: 40px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.detail-image img {
  width: 80%;
  height: auto;
  display: block;
}

/* 产品简介 */
.detail-intro {
  margin-bottom: 40px;
}

.intro-title {
  font-size: 24px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 20px 0;
  padding-bottom: 10px;
  border-bottom: 2px solid #4c95e3;
  display: inline-block;
}

.intro-content {
  font-size: 16px;
  line-height: 1.8;
  color: #333;
  margin: 0;
}

/* 产品优势 */
.detail-advantages {
  margin-bottom: 40px;
}

.advantages-title {
  font-size: 24px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 20px 0;
  padding-bottom: 10px;
  border-bottom: 2px solid #4c95e3;
  display: inline-block;
}

.advantages-content {
  font-size: 16px;
  line-height: 1.8;
  color: #333;
}

.advantages-list {
  margin: 0;
  padding-left: 25px;
  color: #333;
}

.advantages-list li {
  margin-bottom: 10px;
  line-height: 1.8;
}

/* 应用场景 */
.detail-scenarios {
  margin-bottom: 40px;
}

.scenarios-title {
  font-size: 24px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 20px 0;
  padding-bottom: 10px;
  border-bottom: 2px solid #4c95e3;
  display: inline-block;
}

.scenarios-content {
  font-size: 16px;
  line-height: 1.8;
  color: #333;
}

.scenarios-content p {
  margin: 0 0 15px 0;
}

.scenarios-list {
  margin: 0;
  padding-left: 25px;
  color: #333;
}

.scenarios-list li {
  margin-bottom: 10px;
  line-height: 1.8;
}

/* 技术架构 */
.detail-architecture {
  margin-bottom: 0;
}

.architecture-title {
  font-size: 24px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 20px 0;
  padding-bottom: 10px;
  border-bottom: 2px solid #4c95e3;
  display: inline-block;
}

.architecture-content {
  font-size: 16px;
  line-height: 1.8;
  color: #333;
}

.architecture-content p {
  margin: 0 0 20px 0;
}

.tech-stack {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.tech-tag {
  padding: 8px 16px;
  background: #f0f7ff;
  color: #4c95e3;
  border: 1px solid #4c95e3;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .products-header {
    padding: 50px 0;
    min-height: 190px;
  }

  .title-glow {
    font-size: 32px;
    letter-spacing: 1.5px;
  }

  .products-header .container {
    padding: 0 24px;
  }

  .page-subtitle {
    margin-left: 1.5em;
    font-size: 14px;
  }

  .detail-main {
    padding: 30px 0 60px 0;
  }

  .detail-card {
    padding: 30px 20px;
  }

  .detail-title {
    font-size: 26px;
  }

  .detail-meta {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .intro-title,
  .advantages-title,
  .scenarios-title,
  .architecture-title {
    font-size: 20px;
  }

  .intro-content,
  .advantages-content,
  .scenarios-content,
  .architecture-content {
    font-size: 15px;
  }
}

@media (max-width: 480px) {
  .title-glow {
    font-size: 28px;
    letter-spacing: 1px;
  }

  .detail-card {
    padding: 20px 15px;
  }

  .detail-title {
    font-size: 22px;
  }
}

/* 加载和错误状态 */
.detail-loading,
.detail-error {
  text-align: center;
  padding: 60px 20px;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  margin: 0 auto 20px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #4c95e3;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.detail-loading p {
  color: #666;
  font-size: 16px;
}

.detail-error {
  background: #ffecec;
  border-radius: 8px;
  padding: 30px;
}

.detail-error p {
  color: #c0392b;
  margin: 0 0 10px 0;
  font-size: 16px;
}

.error-hint {
  color: #999 !important;
  font-size: 14px !important;
}
</style>

